// onterx
// const firebaseConfig = {
//     apiKey: "AIzaSyA6FGrTB9n_F3Bnf3YD5DF5JlPYVvUBEy8",
//     authDomain: "learn-firebase-c01db.firebaseapp.com",
//     databaseURL: "https://learn-firebase-c01db.firebaseio.com",
//     projectId: "learn-firebase-c01db",
//     storageBucket: "learn-firebase-c01db.appspot.com",
//     messagingSenderId: "558031328876",
//     appId: "1:558031328876:web:bf59570aea33c094d2ea49"
// };

// delphicon.app.001
const firebaseConfig = {
    apiKey: "AIzaSyCy1xVpVQIAzlFINXnn0mqzOqmR-4YJHKY",
    authDomain: "dasta3-e14d4.firebaseapp.com",
    databaseURL: "https://dasta3-e14d4-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "dasta3-e14d4",
    storageBucket: "dasta3-e14d4.appspot.com",
    messagingSenderId: "317059475902",
    appId: "1:317059475902:web:0ff9d492d43c78eb8531ef",
    measurementId: "G-9HK73HHWYY",
    useEmulator: false
  };

export default firebaseConfig;